import { observer } from 'mobx-react-lite'
import { type SearchableUser } from '@/features/iam/users/SearchableUser'
import { ClientUserManagementTableRow } from '@/features/client-user-management/components/ClientUserManagementTableRow'

export interface ClientUserManagementTableRowContainerProps {
  user: SearchableUser
}

export const ClientUserManagementTableRowContainer = observer(
  function ClientUserManagementTableRowContainer({
    user,
  }: ClientUserManagementTableRowContainerProps) {
    return (
      <ClientUserManagementTableRow
        publicId={user.publicId}
        displayName={user.displayName}
        online={user.online}
        email={user.email}
        lastSeen={user.lastSeen}
        dateCreated={user.dateCreated}
      />
    )
  },
)
